<div class="pr-6 pr-96px pt-3" role="main">
  <h1 class="h-1 mb-2-4rem-imp">{{bookmarkmaintile}}</h1>
  <mat-accordion >
    <mat-expansion-panel [expanded] ="false">
      <mat-expansion-panel-header class="mataccordianHeader">
        <div class="matheadertext"> {{accordionRows[0] + " (" + dataSourceCod.data.length + ")"}}</div>
      </mat-expansion-panel-header>
      <table mat-table [dataSource]="dataSourceCod" matSort #TableOneSort="matSort" matSortActive="ParagraphId" matSortDirection="asc" aria-describedby="bmk1">
        <ng-container matColumnDef="Title">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{titleheadername}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortCod?.active=='Title'?'#F0F5FF':null"> {{element.Title}} </td>
        </ng-container>

        <ng-container matColumnDef="ParagraphId">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{bookmarkheadername}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortCod?.active=='ParagraphId'?'#F0F5FF':null">
            <span *ngFor="let items of element.Bookmark; let i = index">
              <span *ngIf="i != element.Bookmark.length-1" [innerHTML]="items| shortText : 30"></span> <img *ngIf="i != element.Bookmark.length-1 && i != element.Bookmark.length-2" class="arrow" src="../../../../assets/icons/Arrow Right (Alt).svg" alt="Arrow Right" />
            </span><span><img class="arrow" src="../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Right Down"></span><br />
            <span class="link font-18 highlight-blue underline cursor-pointer" (click)="NavigateTo(element.BookmarkURL,element.Bookmark[element.Bookmark.length-1])" (keyup.enter)="NavigateTo(element.BookmarkURL,element.Bookmark[element.Bookmark.length-1])" [innerHTML]="element.Bookmark[element.Bookmark.length-1].split('____')[0]"></span>
          </td>
        </ng-container>

        <ng-container matColumnDef="Dateadded">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{dateheadername}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortCod?.active=='Dateadded'?'#F0F5FF':null"> {{element.Dateadded | date:'MM/dd/yyyy'}} </td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th scope="col" mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button aria-label="copy" (click)="copyToClipboard(element.BookmarkURL,element.Title,element.Bookmark, element.ParagraphId)">
              <mat-icon class="copy-clipboard-icon"></mat-icon>
            </button>
            <button mat-icon-button aria-label="delete" (click)="redirectToDelete(element.id)">
              <mat-icon class="delete-icon"></mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>
      <div *ngIf="dataSourceCod.data.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
      <div>
        <mat-paginator #TableOnePaginator="matPaginator" [pageSize]="pagesize" [pageSizeOptions]="pagelistarrayCod"
                       aria-label="Select page of bookmarks">
        </mat-paginator>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header class="mataccordianHeader">
        <div class="matheadertext"> {{accordionRows[1] + " (" + dataSourceOP.data.length + ")"}}</div>
      </mat-expansion-panel-header>
      <table mat-table [dataSource]="dataSourceOP" matSort #TableTwoSort="matSort" matSortActive="ParagraphId" matSortDirection="asc" aria-describedby="bmk2">
        <ng-container matColumnDef="Title">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{titleheadername}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortOP?.active=='Title'?'#F0F5FF':null"> {{element.Title}} </td>
        </ng-container>

        <ng-container matColumnDef="ParagraphId">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{bookmarkheadername}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortOP?.active=='ParagraphId'?'#F0F5FF':null">
            <span *ngFor="let items of element.Bookmark; let i = index">
              <span *ngIf="i != element.Bookmark.length-1" [innerHTML]="items| shortText : 30"> </span> <img *ngIf="i != element.Bookmark.length-1 && i != element.Bookmark.length-2" class="arrow" src="../../../../assets/icons/Arrow Right (Alt).svg" alt="Arrow Right" />
            </span><span><img class="arrow" src="../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Right Down"></span><br />
            <span class="link font-18 highlight-blue underline cursor-pointer" (click)="NavigateTo(element.BookmarkURL,element.Bookmark[element.Bookmark.length-1])" (keyup.enter)="NavigateTo(element.BookmarkURL,element.Bookmark[element.Bookmark.length-1])" [innerHTML]="element.Bookmark[element.Bookmark.length-1].split('____')[0]"></span>

          </td>
        </ng-container>

        <ng-container matColumnDef="Dateadded">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{dateheadername}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortOP?.active=='Dateadded'?'#F0F5FF':null"> {{element.Dateadded | date:'MM/dd/yyyy'}} </td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th scope="col" mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button aria-label="copy" (click)="copyToClipboard(element.BookmarkURL,element.Title,element.Bookmark, element.ParagraphId)">
              <mat-icon class="copy-clipboard-icon"></mat-icon>
            </button>
            <button mat-icon-button aria-label="delete" (click)="redirectToDelete(element.id)">
              <mat-icon class="delete-icon"></mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <div *ngIf="dataSourceOP.data.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
      <div>
        <mat-paginator #TableTwoPaginator="matPaginator" [pageSize]="pagesize" [pageSizeOptions]="pagelistarrayOP"
                       aria-label="Select page of bookmarks">
        </mat-paginator>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header class="mataccordianHeader">
        <div class="matheadertext"> {{accordionRows[2] + " (" + dataSourceCIG.data.length + ")"}}</div>
      </mat-expansion-panel-header>
      <table mat-table [dataSource]="dataSourceCIG" matSort #TableThreeSort="matSort" matSortActive="ParagraphId" matSortDirection="asc" aria-describedby="bmk3">
        <ng-container matColumnDef="Title">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{titleheadername}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortCIG?.active=='Title'?'#F0F5FF':null"> {{element.Title}} </td>
        </ng-container>

        <ng-container matColumnDef="ParagraphId">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{bookmarkheadername}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortCIG?.active=='ParagraphId'?'#F0F5FF':null">
            <span *ngFor="let items of element.Bookmark; let i = index">
              <span *ngIf="i != element.Bookmark.length-1" [innerHTML]="items| shortText : 30"></span>
               <img *ngIf="i != element.Bookmark.length-1 && i != element.Bookmark.length-2" class="arrow" src="../../../../assets/icons/Arrow Right (Alt).svg" alt="Arrow Right" />
            </span><span><img class="arrow" src="../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Right Down"></span><br />
            <span class="link font-18 highlight-blue underline cursor-pointer" (click)="NavigateTo(element.BookmarkURL,element.Bookmark[element.Bookmark.length-1])" (keyup.enter)="NavigateTo(element.BookmarkURL,element.Bookmark[element.Bookmark.length-1])" [innerHTML]="element.Bookmark[element.Bookmark.length-1].split('____')[0]"></span>

          </td>
        </ng-container>

        <ng-container matColumnDef="Dateadded">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{dateheadername}}</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="sortCIG?.active=='Dateadded'?'#F0F5FF':null"> {{element.Dateadded | date:'MM/dd/yyyy'}} </td>
        </ng-container>
        <ng-container matColumnDef="Action">
          <th scope="col" mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button aria-label="copy" (click)="copyToClipboard(element.BookmarkURL,element.Title,element.Bookmark, element.ParagraphId)">
              <mat-icon class="copy-clipboard-icon"></mat-icon>
            </button>
            <button mat-icon-button aria-label="delete" (click)="redirectToDelete(element.id)">
              <mat-icon class="delete-icon"></mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <div *ngIf="dataSourceCIG.data.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
      <div>
        <mat-paginator #TableThreePaginator="matPaginator" [pageSize]="pagesize" [pageSizeOptions]="pagelistarrayCIG"
                       aria-label="Select page of bookmarks">
        </mat-paginator>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
